import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=346eef33&scoped=true&"
import script from "./ErrorBox.vue?vue&type=script&lang=js&"
export * from "./ErrorBox.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBox.vue?vue&type=style&index=0&id=346eef33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346eef33",
  null
  
)

export default component.exports